/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_OverlineInputs */

const en_pb_overline = /** @type {(inputs: Pb_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBOOKS`)
};

const id_pb_overline = /** @type {(inputs: Pb_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBOOK`)
};

/**
* | output |
* | --- |
* | "PLAYBOOKS" |
*
* @param {Pb_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_overline = /** @type {((inputs?: Pb_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_overline(inputs)
	return en_pb_overline(inputs)
});